import React, { ReactNode } from 'react';
import { CloseButton, Flex, Text, ToastProviderProps } from '@chakra-ui/react';

export interface ToastProps extends ToastProviderProps {
  message: string;
  icon?: ReactNode;
  onClose: () => void;
}

export const Toast = ({ message, icon, onClose }: ToastProps) => {
  return (
    <Flex position="relative"
          alignItems="center"
          paddingY="xl"
          paddingX="xxl"
          backgroundColor="warning.200"
          borderRadius="md"
          borderColor="warning.600"
          borderWidth="1px"
          color="warning.800">
      <CloseButton color="warning.800" position="absolute" top=".1em" right=".1em" onClick={onClose} />
      {icon &&
        <Text fontWeight="bold" fontSize="xxxl" marginRight="l">{icon}</Text>
      }
      <Text fontWeight="bold">{message}</Text>
    </Flex>
  );
};
